export default __webpack_public_path__ + "static/media/card-migrate.cb543b6e.png";